import type { FleAppEnv, EnvURLMap } from '@/types/const/serviceEnv';

export const fleAppEnv: FleAppEnv = fleProcess.fleEnv;
type ServerType = 'java';
type BaseURLMap = {
  [K in ServerType]: EnvURLMap;
};
export const baseURLMap: BaseURLMap = {
  java: {
    dev: 'https://dev-gateway.fxqifu.net/pangu',
    qa: 'https://qa-gateway.fxqifu.net/pangu',
    prod: 'https://gateway.fxqifu.net/pangu',
  },
};

type codeType = number;
export const DataCode: Map<string, codeType> = new Map([
  ['SUCCESS', 2000],
  ['LOGIN_ERROR', 100003],
  ['INVALID_LOGIN', 60000013],
]);

export const BaseServiceType = 'java';
export const TokenKey = 'token';
export const BaseURL: string = baseURLMap[BaseServiceType][fleAppEnv] || '';

export type ApplicationType =
  | 'cardStore'
  | 'liguanjia'
  | 'supplier'
  | 'peliten'
  | 'csc'
  | 'manager'
  | 'help';
type ApplicationUrlMapType = {
  [K in ApplicationType]: EnvURLMap;
};

export const ApplicationUrlMap: ApplicationUrlMapType = {
  // 卡券
  cardStore: {
    dev: 'https://qa-cardstore.tmallfx.com',
    qa: 'https://qa-cardstore.tmallfx.com',
    prod: 'https://cardstore.bababuys.com',
  },
  // 礼管家
  liguanjia: {
    dev: `https://qa-liguanjia.tmallfx.com`,
    qa: `https://qa-liguanjia.tmallfx.com`,
    prod: `https://liguanjia.bababuys.com`,
  },
  // 百礼腾
  peliten: {
    dev: 'http://dev-www.peliten.com',
    qa: 'https://qa-www.peliten.com',
    prod: 'https://www.peliten.com',
  },
  // 客服
  csc: {
    dev: 'https://dev-csc.tmallfx.com',
    qa: 'https://qa-csc.tmallfx.com',
    prod: 'https://csc.bababuys.com',
  },
  // 3.0运营后台
  manager: {
    dev: 'https://qa-manager.wowcarp.com',
    qa: 'https://qa-manager.wowcarp.com',
    prod: 'https://manager.wowcarp.com',
  },
  // 供应商端
  supplier: {
    dev: `https://supplier.koudaiqifu.cn`,
    qa: `https://supplier.koudaiqifu.cn`,
    prod: `https://supplier.fxqifu.com`,
  },
  help: {
    dev: 'https://dev-help.tmallfx.com',
    qa: 'https://qa-help.tmallfx.com',
    prod: 'https://help.bababuys.com',
  },
};

export const getApplicationUrl = (application: ApplicationType, router = '') => {
  return `${ApplicationUrlMap[application][fleAppEnv]}${router}`;
};
